var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import "../assets/css/global.scss";
import "core-js/stable";
import Vue from "vue";
import { Component, Provide, } from "vue-property-decorator";
import App from "../components/app.vue";
import I18n from "./internationalization";
import NetworkBroker from "./networkbroker";
import { emptyGraph, emptyShopConfig, objEq, } from "./utilities/aux";
import { isScriptError, } from "./utilities/error";
import { isProjectObject, isShopConfig, } from "./utilities/graph";
import { isExternalAddResult, } from "./utilities/import";
import { isArray, isBoolean, } from "./utilities/wsi4_typeguards";
import { RequestType, } from "./utilities/configuration";
Vue.use(I18n);
function importError(result) {
    if (result.tag === "AddSuccess") {
        throw Error("Wrong tag.");
    }
    return result;
}
let Wsi4WebUi = class Wsi4WebUi extends Vue {
    constructor() {
        super(...arguments);
        this.busy = true;
        this.scriptResult = {
            tag: "ScriptSuccess",
        };
        this.graph = emptyGraph();
        this.readOnlyModeEnabled = false;
        this.save = false;
        this.shopConfig = emptyShopConfig();
        this.possibleWizardVertexKeys = [];
        this.showPartCreationButton = false;
        this.Renderer3d = undefined;
        this.i18n = new I18n();
        this.networkBroker = new NetworkBroker;
    }
    setGraphNodeIds(ids) {
        this.networkBroker.graphNodeIds = ids;
    }
    setLocaleAndCurrency(locale, currency) { this.i18n.setLocaleAndCurrency(locale, currency); }
    setRenderer(r) { this.Renderer3d = r; }
    onCloseWizard() { this.possibleWizardVertexKeys = []; }
    resetScriptResult() {
        this.scriptResult = {
            tag: "ScriptSuccess",
        };
    }
    get isEmpty() { return objEq(this.graph, emptyGraph()); }
    created() {
        this.networkBroker.addSlot(RequestType.graphChanged, (graph) => {
            if (!isProjectObject(graph)) {
                throw Error("graphChanged: Wrong type");
            }
            this.graph = graph;
            if (this.save) {
                this.networkBroker.save();
                this.save = false;
            }
        });
        this.networkBroker.addSlot(RequestType.configChanged, (shopConfig) => {
            if (!isShopConfig(shopConfig)) {
                throw Error("configChanged: Wrong type");
            }
            this.shopConfig = shopConfig;
        });
        this.networkBroker.addSlot("finished", (finished) => {
            if (!isBoolean(finished)) {
                throw Error("finished: Wrong type");
            }
            this.busy = !finished;
        });
        this.networkBroker.addSlot("error", (err) => {
            if (!isScriptError(err)) {
                throw Error("error: Wrong type");
            }
            if (!this.networkBroker.busy) {
                this.busy = false;
            }
            this.scriptResult = err;
        });
        this.networkBroker.addSlot("save", () => { this.busy = true; });
        this.networkBroker.addSlot("request", () => { this.busy = true; });
        this.networkBroker.addSlot("prepare-save", () => { this.save = true; });
        this.networkBroker.addSlot(RequestType.filesChanged, (array) => {
            if (!isArray(array, isExternalAddResult)) {
                throw Error("filesChanged: Wrong type");
            }
            const errors = [];
            const wizardVertexKeys = [];
            for (const result of array) {
                if (result.tag !== "AddSuccess") {
                    errors.push(importError(result));
                }
                else if (this.networkBroker.configuration.showWizard) {
                    for (const key of result.vertexKeys) {
                        wizardVertexKeys.push(key);
                    }
                }
            }
            if (errors.length !== 0) {
                this.networkBroker.error({
                    tag: "ImportErrors",
                    errors: errors,
                });
            }
            else {
                this.possibleWizardVertexKeys = wizardVertexKeys;
            }
        });
        this.networkBroker.addSlot("configuration-changed", () => {
            this.readOnlyModeEnabled = this.networkBroker.configuration.readOnlyModeEnabled;
            this.setLocaleAndCurrency(this.networkBroker.configuration.locale, this.networkBroker.configuration.currencyCode);
            this.i18n.overwriteTranslations(this.networkBroker.configuration.translationOverwrites);
            this.showPartCreationButton = Object.entries(this.networkBroker.configuration.partCreationConfig)
                .some(([_key, value,]) => value);
        });
    }
};
__decorate([
    Provide()
], Wsi4WebUi.prototype, "i18n", void 0);
__decorate([
    Provide()
], Wsi4WebUi.prototype, "networkBroker", void 0);
Wsi4WebUi = __decorate([
    Component({
        components: {
            App,
        },
        name: "Wsi4WebUi",
    })
], Wsi4WebUi);
export default Wsi4WebUi;
